export const orderedKeysErrorStateSocioeconomicDemographic = [
  'typesOfResidence',
  'residenceCondition',
  'dwellersByResidence',
  'genderDistribution',
  'ageDistribution',
  'populationGrowth',
  'householdsByIncome',
  'activePopulation',
  'consumptionByIncome',
  'consumptionByGoods',
];
